// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__QBI7b","footerDisclaimer":"styles_footerDisclaimer__xoPzu","footer":"styles_footer__vuO2s"};